import { useCreateProjectMapMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";
import getLocalString from "constants/Localization";

export default function useCreateProjectMap() {
  const [mutation, { data, loading, error }] = useCreateProjectMapMutation({
    refetchQueries: ["customGetProjectMaps"],
  });

  const [createProjectMap, context] = useBitumioMutation(
    { mutation, data, loading, error, key: "createProjectMap" },
    {
      successMessage: getLocalString("projectMaps.create-success"),
      failureMessage: getLocalString("projectMaps.create-failure"),
    }
  );

  return [createProjectMap, context] as const;
}
